import { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Dropdown,
  FormCheck,
  FormControl,
  FormSelect,
  Table,
} from 'react-bootstrap'
import Pagination from '../reusable/Pagination'
import fetchData from '../utils/fetchData'
import getCookie from '../utils/getCookie'
import { staticUrl } from '../utils/url'
import Add from './Add'
import Delete from './Delete'

const Testimonial = () => {
  // ! hooks
  const [isModal, setModal] = useState(false)
  const [isEdit, setEdit] = useState(false)
  const [testimonials, setTestimonials] = useState([])
  const [testimonialData, setTestimonialData] = useState()
  const [isDelete, setDelete] = useState(false)
  const [id, setId] = useState()
  // ! filter
  const [filter, setFilter] = useState({ search: '', status: '' })
  // ! pagination
  const [page, setPage] = useState(1)
  const [total, setTotal] = useState(0)
  const [limit, setLimit] = useState(10)

  // ! get testimonial data
  const getTestimonials = async () => {
    try {
      const { data } = await fetchData.get(
        `/testimonial?page=${page}&limit=${limit}&filter=${JSON.stringify(
          filter
        )}`,
        { headers: { Authorization: `Bearer ${getCookie('eyevaryToken')}` } }
      )
      setTotal(data?.total)
      setTestimonials(data?.testimonials)
    } catch (error) {
      console.log({ ...error }, error)
    }
  }
  useEffect(() => {
    getTestimonials()
  }, [page, limit, filter])
  useEffect(() => {
    setPage(1)
  }, [filter])

  return (
    <section className='content-wrapper'>
      <Add
        isModal={isModal}
        setModal={setModal}
        isEdit={isEdit}
        setEdit={setEdit}
        setTestimonialData={setTestimonialData}
        testimonialData={testimonialData}
        getTestimonials={getTestimonials}
      />
      <Delete
        isModal={isDelete}
        setModal={setDelete}
        id={id}
        setId={setId}
        getTestimonials={getTestimonials}
      />
      <Card className='mb-4'>
        <Card.Body>
          <div className='d-flex flex-wrap align-items-center justify-content-between'>
            <Card.Title>Testimonials</Card.Title>
            <div className='mb-3'>
              <Button size='sm' onClick={() => setModal(true)}>
                <i className='mdi mdi-plus me-1'></i> Add
              </Button>
            </div>
          </div>
          <div className='filter'>
            <div>
              <FormControl
                type='text'
                placeholder='Search'
                autoComplete='off'
                name='search'
                value={filter.search}
                onChange={({ target }) =>
                  setFilter({ ...filter, [target.name]: target.value })
                }
              />
            </div>
            <div>
              <FormSelect
                autoComplete='off'
                name='status'
                value={filter.status}
                onChange={({ target }) =>
                  setFilter({ ...filter, [target.name]: target.value })
                }>
                <option value=''>All</option>
                <option value='true'>Visible</option>
                <option value='false'>Hidden</option>
              </FormSelect>
            </div>
          </div>
          <Table responsive>
            <thead>
              <tr>
                <th scope='col'>User</th>
                <th scope='col' style={{ minWidth: '35rem' }}>
                  Description
                </th>
                <th scope='col'>Status</th>
                <th
                  scope='col'
                  style={{ maxWidth: '3rem', width: '3rem' }}></th>
              </tr>
            </thead>
            <tbody>
              {testimonials?.map((testimonial) => (
                <tr key={testimonial?._id}>
                  <td className='align-middle text-nowrap'>
                    <div className='table-img'>
                      <img
                        src={
                          testimonial?.avatar
                            ? staticUrl + testimonial?.avatar
                            : '/assets/images/profile.jpg'
                        }
                        alt={testimonial?.username}
                      />
                      <div>
                        <h6>{testimonial?.username}</h6>
                        <p>{testimonial?.company}</p>
                      </div>
                    </div>
                  </td>
                  <td className='align-middle'>
                    <p className='table-description'>
                      {testimonial?.description}
                    </p>
                  </td>
                  <td className='align-middle'>
                    {testimonial?.status ? (
                      <span className='status status-outline-success'>
                        Visible
                      </span>
                    ) : (
                      <span className='status status-outline-danger'>
                        Hidden
                      </span>
                    )}
                  </td>
                  <td className='align-middle text-center'>
                    <Dropdown>
                      <Dropdown.Toggle as='span' className='pnt'>
                        <i className='mdi mdi-dots-vertical'></i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          as='span'
                          className='pnt'
                          onClick={() => {
                            setEdit(true)
                            setModal(true)
                            setTestimonialData(testimonial)
                          }}>
                          Edit
                        </Dropdown.Item>
                        <Dropdown.Item
                          as='span'
                          className='pnt'
                          onClick={() => {
                            setDelete(true)
                            setId(testimonial?._id)
                          }}>
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Pagination
            page={page}
            setPage={setPage}
            total={total}
            limit={limit}
          />
        </Card.Body>
      </Card>
    </section>
  )
}

export default Testimonial
